import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8565d2ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = { class: "row mt-5" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "col-12 mt-4"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Launching app... ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "col-12 mt-4"
}
const _hoisted_9 = { class: "alert alert-danger mb-3" }
const _hoisted_10 = {
  key: 2,
  class: "col-12 mt-3"
}
const _hoisted_11 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.appTitle), 1)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'apps-installed' })))
            }, "Back to installed apps")
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loading && !_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("iframe", {
              ref: "externalFrame",
              name: _ctx.iframeName,
              class: "external-frame",
              title: "External App"
            }, null, 8, _hoisted_11)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}